import React, { useContext, useEffect, useState } from "react"
import styled from "styled-components"
import ChatItem from "../components/ChatItem"
import { FiSearch } from "react-icons/fi"
import ChatDetailItem from "../components/ChatDetailItem"
import {
  collection,
  query,
  where,
  orderBy,
  updateDoc,
  doc,

  onSnapshot,
} from "firebase/firestore"
import { db, useAuth } from "../firebase-config"
import { useParams } from "react-router-dom"
import { ProductDetailContext } from "../context/ProductDetailsProvider"

function ChatScreen() {
  const [selectedChat, setSelectedChat] = useState(null)
  const [usersArr, setUsersArr] = useState([])
  const [convUserArr, setConvUserArr] = useState([])
  const [msgs, setMsgs] = useState([])
  const currentUser = useAuth()
  const {uid} = useParams()

  const productContext = useContext(ProductDetailContext)
  
  const user1 = currentUser.uid
 
  let placeholderAvatar ="https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png"
  const [isGroup, setIsGroup] = useState(false)
 
  const handleChatItemClick = async item => {
    setSelectedChat(item)
    console.log(item)
    setIsGroup(false)
    const user2 = item?.uid
    const id = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`
    
    const msgsRef = collection(db, "messages", id, "chat")
    const q = query(msgsRef, orderBy("createdAt", "asc") )

    onSnapshot(q, querySnapshot => {
      let msgs = []
      querySnapshot.forEach(doc => {
        msgs.push(doc.data())
      })
      setMsgs(msgs)
      console.log(msgs)
    })
    // get last message b/w logged in user and selected user
    // const docSnap = await getDoc(doc(db, "lastMsg", id));
    // if last message exists and message is from selected user
    // if (docSnap.data() && docSnap.data().from !== user1) {
    // update last message doc, set unread to false
    //   await updateDoc(doc(db, "lastMsg", id), { unread: false });
    // }
  }
 
  // pass uid+ productId in url
  // everthing will be same just create one collection with uid+for+productid
  //pass 0 if not enquiry that means if product id is true then only call enquiry function

  // const handleGrpItemClick = async item => {
  //   setSelectedChat(item)
  //   console.log('item',item)
  //   setIsGroup(true)
  //   const user2 = uid
  //   const id = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`
  //   const grpId =  `${user1}to${uid}fp${productId}`
  //   const msgsRef = collection(db, "messages", id, grpId)
  //   const q = query(msgsRef, orderBy("createdAt", "asc") )
    

  //   onSnapshot(q, querySnapshot => {
  //     let msgs = []
  //     querySnapshot.forEach(doc => {
  //       msgs.push(doc.data())
  //     })
  //     setMsgs(msgs)
  //     console.log(msgs)
  //   })
  // }



  useEffect(() => {
    const userRef = collection(db, "users")


    if(currentUser?.uid){
        const q = query(userRef, where('uid', '!=', user1))
        console.log(uid)
        const unsub = onSnapshot(q, querySnapshot => {
            let users = []
          querySnapshot.forEach((doc) => {
            users.push(doc.data())
          })

          setUsersArr(users)

          if( uid != 0 ){
            console.log('updating')
            updateDoc(doc(db, "users", uid), {
              inConv: [currentUser.uid]
            })
            let selChat = users.filter((user) => user.uid === uid)
            console.log(selChat[0])
            handleChatItemClick(selChat[0])
            productContext.handleUser2Id(selChat[0].uid)
          }
        })

        return unsub 
    }
        
  }, [currentUser?.uid])

  
  


  return (
    <>
      <ChatScreenWrap>
        <ChatComp>
          <ChatListCont>
            <ChatSearchBox>
              <FiSearch size={20} color="#888888" />
              <SearchInput></SearchInput>
            </ChatSearchBox>
            {usersArr.length != 0 &&
              usersArr.map((item, index) => {
                return (
                  <ChatItem
                    key={index}
                    user1={user1}
                    user={item}
                    handleChatClick={() => handleChatItemClick(item)}
                    chatPersonImg={item?.personalInfo?.profilePic? item.personalInfo.profilePic : placeholderAvatar}
                    chatPersonName={item.personalInfo?.name}
                  />
                )
              })}
            {/* {convUserArr.length != 0 &&
              convUserArr.filter((item) => item.uid === user1).map((item, index) => {
                return (
                  <ChatItem
                    key={index}
                    user1={user1}
                    user={item}
                    handleChatClick={() => handleChatItemClick(item)}
                    chatPersonImg={item?.personalInfo?.profilePic? item.personalInfo.profilePic : placeholderAvatar}
                    chatPersonName={item.personalInfo.name}
                  />
                )
              })} */}
              
            {/* {groupsArr.length != 0 &&
              groupsArr.map((item, index) => {
                return (
                  <ChatItem
                    key={index}
                    user1={user1}
                    user={false}
                    handleChatClick={() => handleGrpItemClick(groupsArr[0])}
                    chatPersonImg={item?.productDetail?.productDetails?.productPhoto? item.productDetail?.productDetails?.productPhoto : placeholderAvatar}
                    chatPersonName={item?.productDetail?.productDetails?.productName}
                  />
                )
              })} */}
          </ChatListCont>
          <ChatDetailsCont>
            <ChatDetailItem convo={msgs} user={selectedChat} isGroup={isGroup} secUser={uid} productId={null}/>
          </ChatDetailsCont>
        </ChatComp>
      </ChatScreenWrap>
    </>
  )
}

export default ChatScreen

const ChatScreenWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  height: 85vh;
  background: var(--smoke-white);

  @media (max-width: 768px) {
    height: 87.2vh;
  }
`
const ChatComp = styled.div`
  display: flex;
  background: var(--white);
  width: 80%;
  margin-top: 2rem;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0rem;
  }
`
const ChatListCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  max-width: 30%;
  align-items: center;
  background: ${({ theme }) => theme.background};
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--p-red);
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
  }
`
const ChatDetailsCont = styled.div`
  display: flex;
  width: 70%;
  max-width: 70%;
  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
    display: none;
  }
`

const ChatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 87%;
  background: var(--white);
  padding: 1rem 0rem;
  label {
    font-size: 1.2rem;
    font-weight: 500;
  }
`
const ChatSearchBox = styled.div`
  display: flex;
  background: var(--white);
  border: 1px solid var(--smoke-white);
  border-radius: 5px;
  width: 85%;
  height: 2rem;
  align-items: center;
  padding: 0.5rem;
  box-shadow: 20px 20px 80px rgba(0, 0, 0, 0.1);
  padding-right: 1rem;
  margin: 1rem 0rem;
`

const SearchInput = styled.input`
  background: var(--white);
  border: none;
  width: 100%;
  padding-left: 0.5rem;
  :focus {
    outline: none;
  }
`
